const StatusPopup = ({ message }) => {
	if (!message) return null
	return (
		<div className="status-popup">
			<span className="status-popup-msg">{message}</span>
		</div>
	)
}

export default StatusPopup
